'use client';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Contact() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="min-h-screen">
        <ContactHero language={language} />
        <ContactForm language={language} />
      </main>
      <Footer />
    </>
  );
}